import { FormModal } from "../base";
import { PrivacySettingsForm, PrivacySettingsFormData } from "./PrivacySettingsForm";

type PrivacySettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: PrivacySettingsFormData;
  onSave: (config: PrivacySettingsFormData) => void;
  organizationId: string;
};

export const PrivacySettingsDialog = ({ isOpen, onClose, config, onSave, organizationId }: PrivacySettingsDialogProps) => {
  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      config={config}
      title="Privacy Settings"
      saveLabel="Save & Deploy"
      className="w-full max-w-[600px] min-w-0 max-h-[90vh] mx-4"
    >
      {({ localConfig, onChange }) => (
        <PrivacySettingsForm
          config={localConfig}
          onChange={onChange}
          organizationId={organizationId}
        />
      )}
    </FormModal>
  );
};
